<template>
  <div :key="_key" class="form-group ">
    <label v-if="title" class="text-primary">{{ title }}</label>
    <div class="row">
      <div class="col">
        <div class="input-group d-flex flex-row" v-if="showSearch">
          <!-- <div id="button-addon3" class="input-group-prepend"><span id="basic-addon1" class="input-group-text"><i class="fas fa-search"></i></span></div> -->
          <div style="flex:4; position:relative" class="relative">
            <!-- <a href="#" class="avatar avatar-sm rounded-circle" style="position:absolute; top:4px; right:6px; z-index:100">
          <span>3+</span>
        </a> -->
            <el-select
              v-model="selectedUser"
              value-key="id"
              filterable
              remote
              class="input-normal select-danger radius-0"
              style="flex:9"
              :placeholder="placeholder"
              :remote-method="searchUsers"
              @change="onUserSelected"
              :loading="searching"
              no-data-text="No results"
            >
              <el-option
                v-for="item in foundUsers"
                :key="item.id"
                :label="item.first_name + ' ' + item.last_name"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>

          <div class="input-group-append" v-if="false">
            <button
              id="inviteForm5"
              class="btn btn-success"
              type="button"
              data-toggle="collapse"
              href="#assignForm5"
              role="button"
              aria-expanded="false"
              @click="
                createUserExpaned = !createUserExpaned;
                selectedUser = null;
              "
            >
              <i class="fas fa-user-plus" />
            </button>
          </div>
        </div>
        <div
          v-if="assignedUsers && !multi && showSelectedNames"
          id="assignList55"
          class="hiddenToggle w-100"
          :style="{ marginTop: '10px' }"
        >
          <ul
            v-if="assignedUsers.user && assignedUsers.user.first_name"
            class="list-group list-group-flush list my--3"
          >
            <li class="list-group-item px-0">
              <div class="row align-items-center mx-0">
                <div class="col-auto px-1">
                  <!-- Avatar -->
                  <a href="#" class="avatar avatar-sm rounded-circle">
                    <img
                      v-if="assignedUsers.user && assignedUsers.user.image"
                      alt="Image placeholder"
                      :src="assignedUsers.user.image"
                    />

                    <span v-else>
                      {{
                        assignedUsers.user.first_name &&
                          assignedUsers.user.first_name
                            .toUpperCase()
                            .substring(0, 1)
                      }}
                      {{
                        assignedUsers.user.last_name &&
                          assignedUsers.user.last_name
                            .toUpperCase()
                            .substring(0, 1)
                      }}
                    </span>
                  </a>
                </div>
                <div class="col ml-1 px-1 lh-1">
                  <h6 class="mb-0 lh-1">
                    <a href="#!" class="d-block"
                      >{{
                        assignedUsers.user.first_name &&
                          assignedUsers.user.first_name
                      }}
                      {{
                        assignedUsers.user.last_name &&
                          assignedUsers.user.last_name
                      }}</a
                    >
                  </h6>
                  <!-- <span class="text-success">●</span> -->
                  <small class="text-muted">{{
                    assignedUsers.user.email == profile.email
                      ? "You"
                      : assignedUsers.user.email
                  }}</small>
                </div>

                <div class="col-auto px-1" v-if="multi">
                  <button
                    type="button"
                    @click="onRemoveUserClicked(assignedUsers, 0)"
                    aria-label="Close"
                    class="close"
                    v-tooltip.top-center="`Remove this user`"
                  >
                    <span>×</span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div
          id="assignList5"
          class="hiddenToggle w-100"
          v-if="
            (assignedUsers.length > 0 || defaults.length > 0) &&
              multi &&
              showSelectedNames
          "
        >
          <ul class="list-group list-group-flush list my--3">
            <li
              v-for="(au, ind) in defaults"
              :key="ind"
              class="list-group-item px-0"
            >
              <div class="row align-items-center mx-0">
                <div class="col-auto px-1">
                  <!-- Avatar -->
                  <a href="#" class="avatar avatar-sm rounded-circle">
                    <img
                      v-if="au.user && au.user.image"
                      alt="Image placeholder"
                      :src="au.user.image"
                    />

                    <span v-else
                      >{{
                        au.user.first_name &&
                          au.user.first_name.toUpperCase().substring(0, 1)
                      }}
                      {{
                        au.user.last_name &&
                          au.user.last_name.toUpperCase().substring(0, 1)
                      }}
                    </span>
                  </a>
                </div>
                <div class="col ml-1 px-1">
                  <h5 class="mb-0">
                    <a href="#!" class="d-block"
                      >{{ au.user.first_name && au.user.first_name }}
                      {{ au.user.last_name && au.user.last_name }} (Default)</a
                    >
                  </h5>
                  <!-- <span class="text-success">●</span> -->
                  <small>{{
                    au.user.email == profile.email ? "You" : au.user.email
                  }}</small>
                </div>
              </div>
            </li>

            <li
              v-for="(au, ind) in assignedUsers"
              :key="ind"
              class="list-group-item px-0"
            >
              <div class="row align-items-center mx-0">
                <div class="col-auto px-1">
                  <!-- Avatar -->
                  <a href="#" class="avatar avatar-sm rounded-circle">
                    <img
                      v-if="au.user && au.user.image"
                      alt="Image placeholder"
                      :src="au.user.image"
                    />

                    <span v-else
                      >{{
                        au.user.first_name &&
                          au.user.first_name.toUpperCase().substring(0, 1)
                      }}
                      {{
                        au.user.last_name &&
                          au.user.last_name.toUpperCase().substring(0, 1)
                      }}</span
                    >
                  </a>
                </div>
                <div class="col ml-1 px-1">
                  <h5 class="mb-0">
                    <a href="#!" class="d-block"
                      >{{ au.user.first_name && au.user.first_name }}
                      {{ au.user.last_name && au.user.last_name }}</a
                    >
                  </h5>
                  <!-- <span class="text-success">●</span> -->
                  <small>{{
                    au.user.email == profile.email ? "You" : au.user.email
                  }}</small>
                </div>

                <div class="col-auto px-1">
                  <button
                    type="button"
                    @click="onRemoveUserClicked(au, ind)"
                    aria-label="Close"
                    class="close"
                    v-tooltip.top-center="`Remove this user`"
                  >
                    <span>×</span>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="col">
        <div
          id="assignForm5"
          class="collapse multi-collapse"
          :class="{ show: createUserExpaned || true }"
        >
          <div class="card card-body rounded-0 border-0">
            <div class="form-group">
              <label class=" h6 font-weight-bold">
                <small class="font-weight-bold">Full Name</small>
              </label>
              <input
                v-model="userInvite.full_name"
                type="text"
                class="form-control"
                placeholder="Enter Full Name"
              />
            </div>
            <div class="form-group">
              <label class=" h6 font-weight-bold">
                <small class="font-weight-bold">Email</small>
              </label>
              <input
                v-model="userInvite.email"
                type="email"
                class="form-control"
                name="email"
                placeholder="Enter Email"
              />
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <button
                  class="btn btn-outline-primary btn btn-block"
                  type="button"
                  data-toggle="collapse"
                  @click="btnUserInviteClicked"
                >
                  Invite
                </button>
              </div>
              <div class="col-sm-12 col-md-6" v-if="false">
                <button
                  class="btn btn-outline-primary btn btn-block"
                  type="button"
                  data-toggle="collapse"
                  @click="btnUserCopyLinkClicked"
                >
                  Copy Link
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name: "UserPicker",
  props: {
    showSearch: {
      type: Boolean,
      default: true
    },
    showSelectedNames: {
      type: Boolean,
      default: true
    },
    value: {
      type: [Object, Array]
    },
    title: String,
    multi: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "Search and add from your Bracket network"
    },
    role: String,
    _key: Number,
    title: String,
    skipList: {
      type: Array,
      default: () => []
    },
    defaults: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedUser: null,
      assignedUsers: this.multi ? this.value || [] : this.value || { user: {} },
      userInvite: {},
      foundUsers: [],
      searching: false,
      createUserExpaned: false
    };
  },

  watch: {
    value(oldVal, newVal) {
      if (oldVal != newVal) {
        this.assignedUsers = this.multi
          ? this.value || []
          : this.value || { user: {} };
      }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles"])
  },
  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    searchUsers(query) {
      if (query !== "") {
        this.searching = true;
        this.fetchAllUsers(query).then(
          r => {
            this.foundUsers = r.data.filter(u => {
              let alreadyThere = this.skipList.some(su => su.user.id == u.id);
              return u.id != this.profile.id && !alreadyThere;
            });

            this.foundUsers = this.foundUsers.filter(u => {
              return u.id != this.profile.id;
            });

            if (this.multi) {
              this.foundUsers = this.foundUsers.filter(u => {
                let alreadyThere = this.value.some(su => su.user.id == u.id);
                return !alreadyThere;
              });
            } else {
              this.foundUsers = this.foundUsers.filter(u => {
                return u.id != this.value && this.value.user.id;
              });
            }

            this.searching = false;
          },
          e => {
            this.searching = false;
          }
        );
      } else {
        this.foundUsers = [];
        this.searching = false;
      }
    },

    onRemoveUserClicked(user, index) {
      if (this.multi) {
        this.assignedUsers = this.assignedUsers.filter((u, i) => i != index);
      } else {
        this.assignedUsers = { user: {} };
      }
      //alert(index)
      console.log(this.assignedUsers, "assigned users");
      this.$emit("input", this.assignedUsers);
      this.$emit("userRemoved", this.assignedUsers);
    },

    btnUserInviteClicked(copyLink = false) {
      if (this.userInvite.email == null || this.userInvite.email == "") {
        this.$snack.success("email is required");
        return;
      }

      if (
        this.userInvite.full_name == null ||
        this.userInvite.full_name == ""
      ) {
        this.$snack.success("Name is required");
        return;
      }

      let firstName = "";
      let lastName = "";

      if (this.userInvite.full_name != "") {
        firstName = this.userInvite.full_name
          .split(" ")
          .slice(0, -1)
          .join(" ");

        lastName = this.userInvite.full_name
          .split(" ")
          .slice(-1)
          .join(" ");
      }

      if (!firstName || firstName == "") {
        firstName = this.userInvite.full_name;
      }

      if (lastName == firstName) {
        lastName = "";
      }

      if (this.multi) {
        this.assignedUsers.push({
          user: {
            id: null,
            first_name: firstName,
            last_name: lastName,
            email: this.userInvite.email
          },
          asset_role: this.roles.filter(r => r.name == this.role)[0]
        });
      } else {
        this.assignedUsers = {
          user: {
            id: null,
            first_name: firstName,
            last_name: lastName,
            email: this.userInvite.email
          },
          asset_role: this.roles.filter(r => r.name == this.role)[0]
        };
      }

      this.$emit("input", this.assignedUsers);

      this.userInvite = {};
      this.createUserExpaned = false;
      this.$emit("userSelected", this.assignedUsers);
    },

    onUserSelected() {
      // console.log(this.assignedUsers, "hahahahah")
      if (this.multi) {
        if (!this.assignedUsers) {
          this.assignedUsers = [];
        }

        let userThere = this.assignedUsers.some(u => {
          return u.user.id == this.selectedUser.id;
        });

        if (!userThere) {
          this.assignedUsers.push({
            user: this.selectedUser,
            asset_role: this.roles.filter(r => r.name == this.role)[0]
          });
        }
      } else {
        this.assignedUsers = {
          user: this.selectedUser,
          asset_role: this.roles.filter(r => r.name == this.role)[0]
        };
      }

      this.$emit("input", this.assignedUsers);

      this.selectedUser = {};
      this.$emit("userSelected", this.assignedUsers);
    }
  }
};
</script>
